import apiService from './ApiService';
import ctaCteApiService from './CtaCteApiService';

class UsuarioService {
  async login(email, password) {
    const response = await ctaCteApiService.login(email, password);
    if (response.token) {
      apiService.setAuthToken(response.token);
    }
    return response;
  }

  async logout() {
    apiService.setAuthToken(null);
  }

  async updatePassword(currentPassword, newPassword, repeatNewPassword) {
    return apiService.put('/ctacte/auth/update-password', {
      currentPassword,
      newPassword,
      repeatNewPassword
    });
  }
}

const usuarioService = new UsuarioService();
export default usuarioService;
